import React, { useEffect, useState } from 'react';
import * as CL from './index.styled';
import axiosRequest from '@/api';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { ResData } from '@/@types';
import { CampaignData, CampaignResponse } from '@/@types/CampaignData';
import { Modal, Select } from 'antd';


const { Option } = Select;

const MobileCampaignList = () => {
  const [campaigns, setCampaigns] = useState<CampaignData[]>([]);
  const [totalAvailablePoints, setTotalAvailablePoints] = useState(0);
  const [sortingKey, setSortingKey] = useState('a');
  const [activeTab, setActiveTab] = useState('a');
  const [isJoined, setIsJoined] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [loadError, setLoadError] = useState(false);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const targetDate = searchParams.get('target_date');


  const fetchCampaigns = async () => {
    const page = 1;
    const size = 100;
    const filter = activeTab;

    try {
      const targetDateParam = targetDate ? `&target_date=${targetDate}` : '';
      const response = await axiosRequest.requestAxios<ResData<CampaignResponse>>(
        'get',
        `/admin_active_campaign?page=${page}&size=${size}&sorting=${sortingKey}&filter=${filter}${targetDateParam}`,
      );
      setCampaigns(response.data.result);
    } catch (error) {
      console.error('Fetching campaigns failed:', error);
    }
  };

  useEffect(() => {
    if (activeTab !== 'place') {
      fetchCampaigns();
    }
  }, [navigate, sortingKey, activeTab, isAgreed, isJoined]);

  const handleSortingChange = (value: string) => {
    setSortingKey(value);
  };

  const selectTab = (tabValue: string) => {
    setActiveTab(tabValue);
  };

  const handleIframeError = () => {
    setLoadError(true);
  };

  return (
    <CL.CampaignWrapper>
      <CL.WepickBoxContainer>
        <img src="/assets/img/wepick_logo.png" alt="wereward logo" style={{ width: '190px', height: '30px' }} />
      </CL.WepickBoxContainer>
      <CL.Tabs>
        <CL.Tab isSelected={activeTab === 'a'} onClick={() => selectTab('a')}>
          참여하기
        </CL.Tab>
        <CL.Tab isSelected={activeTab === 'place'} onClick={() => selectTab('place')}>
          플레이스
        </CL.Tab>
        <CL.Tab isSelected={activeTab === 'v'} onClick={() => selectTab('v')}>
          방문하기
        </CL.Tab>
      </CL.Tabs>
      {activeTab === 'place'
        ? (!loadError
          ? <iframe
            src={`https://ad-dev.3dpop.kr/SKT/?user_id=sdfsdfsdfsfs`}
            style={{
              width: '100%',
              height: 'calc(100vh - 200px)',
              border: 'none',
              marginTop: '20px'
            }}
            title="SKT Place"
            allow='clipboard-write * attribution-reporting'
            sandbox='allow-scripts allow-same-origin allow-popups allow-clipboard-write allow-popups-to-escape-sandbox allow-modals'
            onError={handleIframeError}

          />
          : <CL.IFError>
            <h3>콘텐츠를 불러올 수 없습니다.</h3>
            <p>다음 방법을 시도해보세요:</p>
            <ul>
              <li>Safari 설정에서 콘텐츠 차단기 설정 확인</li>
              <li><a href={`https://ad.3dpop.kr/SKT/?user_id=dfsdfsdfsd`} target="_blank"
                rel="noopener noreferrer">콘텐츠 직접 보기</a></li>
            </ul>
          </CL.IFError>
        )
        : campaigns.map((campaign, index) => (
          <CL.CampaignContainer key={index}>
            <CL.CampaignBox>
              <CL.BannerImage src={campaign.small_banner_img} alt={campaign.title} />
              <CL.CampaignInfo>
                <CL.CampaignInfoText>
                  <CL.CampaignTitle>{campaign.title}</CL.CampaignTitle>
                  {campaign.display_name}
                </CL.CampaignInfoText>
                <CL.CampaignInfoBtn>
                  {campaign.is_participated ? '참여 완료' : `${campaign.total_points_per_participant.toLocaleString('ko-KR')}P`}
                </CL.CampaignInfoBtn>
              </CL.CampaignInfo>
            </CL.CampaignBox>
          </CL.CampaignContainer>
        ))
      }
    </CL.CampaignWrapper>
  );
};

export default MobileCampaignList;